import { PageTimePeriod } from 'src/types/page-time-period.enum';
import SpendingBudgetWrapper from './SpendingBudget';

export default function MonthlySpendingBudget(): JSX.Element {
    return SpendingBudgetWrapper({
        timePeriod: PageTimePeriod.CURRENT_MONTH
    });
}
